module.exports = "./img/a22488f09b587994e0d2bc470f7ae30c.png";